/* Amares Homes — product card selection and add to cart.
 *
 * The whole variant matrix is emitted with the card, so choosing a colour or
 * size is instant and costs no request. The button adds exactly the variant
 * shown, and hands the response to Craft's own cart element so the drawer
 * behaves the same as it does everywhere else.
 */
(function () {
  'use strict';

  function Card(root) {
    this.root = root;
    this.priceEl = root.querySelector('[data-amx-card-price]');
    this.wasEl = root.querySelector('[data-amx-card-was]');
    this.flagEl = root.querySelector('[data-amx-card-flag]');
    this.img = root.querySelector('[data-amx-card-media] img');
    // Seeded from what Liquid already rendered, so the opening variant only
    // triggers a fetch when it genuinely differs from the image on screen.
    this.shown = this.img ? this.img.getAttribute('src') : null;
    this.addBtn = root.querySelector('[data-amx-card-add]');
    this.addLabel = root.querySelector('[data-amx-card-add-label]');
    this.buttons = Array.prototype.slice.call(root.querySelectorAll('[data-amx-card-option]'));

    var payload = root.querySelector('[data-amx-card-variants]');
    try {
      this.variants = payload ? JSON.parse(payload.textContent) : [];
    } catch (e) {
      this.variants = [];
    }
    if (!this.variants.length) return;

    this.defaultLabel = this.addLabel ? this.addLabel.textContent.trim() : 'Add to cart';
    this.selection = this.initialSelection();
    this.bind();
    this.update();
  }

  /** Start from the first available variant, so a card never opens sold out. */
  Card.prototype.initialSelection = function () {
    var first = null;
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].available) {
        first = this.variants[i];
        break;
      }
    }
    if (!first) first = this.variants[0];
    return (first.options || []).slice();
  };

  Card.prototype.bind = function () {
    var self = this;
    this.buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-amx-card-option'), 10) - 1;
        self.selection[pos] = btn.getAttribute('data-amx-card-value');
        self.update();
      });
    });

    if (this.addBtn && this.addBtn.tagName === 'BUTTON') {
      this.addBtn.addEventListener('click', function () {
        self.add();
      });
    }
  };

  Card.prototype.find = function () {
    var sel = this.selection;
    for (var i = 0; i < this.variants.length; i++) {
      var opts = this.variants[i].options || [];
      var hit = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] != null && opts[j] !== sel[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return this.variants[i];
    }
    return null;
  };

  Card.prototype.update = function () {
    var variant = this.find();
    this.current = variant;

    this.buttons.forEach(function (btn) {
      var pos = parseInt(btn.getAttribute('data-amx-card-option'), 10) - 1;
      var on = this.selection[pos] === btn.getAttribute('data-amx-card-value');
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }, this);

    if (this.priceEl && variant) this.priceEl.textContent = variant.price;

    /* Compare-at is per variant, so a colour can be on sale while another is
     * not. Hidden rather than emptied, so the row does not keep a gap where
     * the old price was. */
    var was = variant && variant.compare;
    if (this.wasEl) {
      this.wasEl.textContent = was || '';
      this.wasEl.hidden = !was;
    }
    if (this.priceEl) this.priceEl.classList.toggle('amx-card__price--sale', !!was);
    if (this.flagEl) this.flagEl.hidden = !was;

    this.paint(variant);

    var sellable = variant && variant.available;
    if (this.addBtn && this.addBtn.tagName === 'BUTTON') {
      this.addBtn.disabled = !sellable;
      this.addBtn.classList.toggle('amx-card__add--out', !sellable);
    }
    if (this.addLabel) {
      this.addLabel.textContent = sellable
        ? this.defaultLabel
        : variant
        ? window.variantStrings?.soldOut || 'Sold out'
        : window.variantStrings?.unavailable || 'Unavailable';
    }
  };

  /**
   * The rendered <img> carries a srcset, and a srcset beats src — setting src
   * alone changes an attribute the browser then ignores, which is why the
   * swatches appeared to do nothing. Both are set, together.
   *
   * A colour with no photo of its own falls back to the product image rather
   * than keeping the previous colour on screen, which would be a lie about
   * what is selected.
   */
  Card.prototype.paint = function (variant) {
    if (!this.img) return;
    var src = (variant && variant.image) || this.root.dataset.amxCardFallback;
    var set = (variant && variant.srcset) || this.root.dataset.amxCardFallbackSrcset;
    if (!src || src === this.shown) return;
    this.shown = src;

    if (set) this.img.setAttribute('srcset', set);
    else this.img.removeAttribute('srcset');
    this.img.src = src;
  };

  Card.prototype.add = function () {
    if (!this.current || !this.current.available || this.pending) return;
    var self = this;
    this.pending = true;

    var cart =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var body = { items: [{ id: this.current.id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    this.addBtn.classList.add('amx-card__add--busy');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          // Rather than swallow it, send them to the product page where the
          // real form can report properly.
          window.location = self.root.dataset.amxCardUrl;
          return;
        }
        if (cart) {
          cart.renderContents(res);
          cart.classList.remove('is-empty');
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function () {
        window.location = self.root.dataset.amxCardUrl;
      })
      .finally(function () {
        self.pending = false;
        self.addBtn.classList.remove('amx-card__add--busy');
      });
  };

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-amx-card]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.amxBound) return;
      root.dataset.amxBound = '1';
      new Card(root);
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
